import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useCreateFolderByTypologyAsync } from '@/features/easy/preFolderQualification/apis/useCreateFolderTypology';
import { CROSSING_DIRECTION_COUNTRY } from '@/features/shared/constants';
import { isBorderCrossingRoRo } from '@/features/shared/helpers/typologies';

import { useAddAdditionalInformationToFolderAsync } from '../apis';
import { RegisterNewFolderForm } from '../types';

export const useCreateFolderByTypology = () => {
  const { folderId } = useParams();

  const [isCreateNewFolderInError, setIsCreateNewFolderInError] = useState<boolean>(false);

  const { mutate: createNewFolderByTypology, isLoading: isCreateNewFolderByTypologyPending } =
    useCreateFolderByTypologyAsync();

  const { mutate: addAdditionalInformationToFolderAsync, isLoading: isAddAdditionalInformationToFolderAsyncPending } =
    useAddAdditionalInformationToFolderAsync();

  const handleCreateNewFolder = useCallback(
    (direction: string) => (data: RegisterNewFolderForm) => {
      const {
        folderTypologyId,
        vehicleNationality,
        haulierEuEoriNumber,
        haulierGbEoriNumber,
        containsEmptyPackages,
        internalClientReference,
      } = data;

      const isContainsEmptyPackages = containsEmptyPackages ? JSON.parse(containsEmptyPackages) : false;

      createNewFolderByTypology(
        {
          folderTypologyId,
          folderId,
        },
        {
          onSuccess: () => {
            addAdditionalInformationToFolderAsync(
              {
                data: {
                  vehicleNationality,
                  internalClientReference,
                  containsEmptyPackages: isContainsEmptyPackages,
                },
                folderTypologyId,
                folderId,
              },
              {
                onSuccess: () => {
                  setIsCreateNewFolderInError(false);

                  const urlBase = `/folders/${folderId}/customs-documents`;

                  if (!isBorderCrossingRoRo({ folderTypologyId })) {
                    window.location.href = urlBase;
                  } else {
                    const isEuToUk = direction === CROSSING_DIRECTION_COUNTRY.EUUK;
                    const paramKey = isEuToUk ? 'haulierGbEoriNumber' : 'haulierEuEoriNumber';
                    const paramValue = isEuToUk ? haulierGbEoriNumber : haulierEuEoriNumber;

                    // TODO: Debug pourquoi lors de la navigation avec navigate on charge le caches des precedentes requetes du dossier cosulté avant la creation
                    // navigate(`/folders/${folderId}/customs-documents`);

                    window.location.href = `${urlBase}?${paramKey}=${paramValue?.trim().replace(/\s/g, '')}`;
                  }
                },
                onError: () => {
                  setIsCreateNewFolderInError(true);
                },
              },
            );
          },
          onError: () => {
            setIsCreateNewFolderInError(true);
          },
        },
      );
    },
    [folderId, addAdditionalInformationToFolderAsync, createNewFolderByTypology],
  );

  const handleCloseToaster = useCallback(() => {
    setIsCreateNewFolderInError(false);
  }, []);

  const isAddNewFolderByTypologyPending =
    isCreateNewFolderByTypologyPending || isAddAdditionalInformationToFolderAsyncPending;

  return {
    isAddNewFolderByTypologyPending,
    isCreateNewFolderInError,
    handleCreateNewFolder,
    handleCloseToaster,
  };
};
